var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSidebarRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#292d32",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m21.97 15v-6c0-5-2-7-7-7h-6.00003c-5 0-7 2-7 7v6c0 5 2 7 7 7h6.00003c5 0 7-2 7-7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.97 2v20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.96997 9.43994 2.56003 2.55996-2.56003 2.56"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarRight);
export default __webpack_public_path__ + "static/media/sidebar-right.b231e9620aef280ac322c87e6c2b4471.svg";
export { ForwardRef as ReactComponent };